<template>
  <div class="list-container">
    <ul class="list-container__nav">
      <li v-for="(link, id) in navLinks" :key="id">
        <router-link class="list-container__link" :to="{ name: link.to }">{{
          link.text
        }}</router-link>
        <div class="nav-bar"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  DASHBOARD_PAGE_NAME,
  MY_OVERVIEW_PAGE_NAME,
  MY_ACCOUNT_PAGE_NAME,
  CREATORS_CLUB_PRIVATE_PAGE_NAME,
  CREATORS_CLUB_PUBLIC_PAGE_NAME,
  MY_SERVERS_PAGE_NAME,
} from '@/router/pageNameConstants.js';

export default {
  name: 'SidebarList',
  data() {
    return {
      navLinks: [
        { id: 1, text: 'My Creations', to: DASHBOARD_PAGE_NAME },
        { id: 2, text: 'My Overview', to: MY_OVERVIEW_PAGE_NAME },
        { id: 3, text: 'My Account', to: MY_ACCOUNT_PAGE_NAME },
        { id: 4, text: 'My Servers', to: MY_SERVERS_PAGE_NAME },

        // {
        //     id: 5,
        //     text: 'Creators Club',
        //     to: CREATORS_CLUB_PRIVATE_PAGE_NAME,
        // },
        // {
        //   id: 6,
        //   text: 'Support / Help',
        //   to: CREATORS_CLUB_PUBLIC_PAGE_NAME,
        // },
      ],
      activeOption: '',
    };
  },
};
</script>

<style scoped lang="scss">
.list-container {
  display: inline-grid;
  grid-auto-rows: 6rem;
  margin: 0;

  ul {
    list-style-type: none;
  }

  &__link {
    width: 308px;
    height: 42px;
    color: $blue-main;
    font-family: $istok-font;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0.38px;
    line-height: 53px;
    transition: all $transition-values;

    &:visited,
    &:hover {
      font-weight: 700;
      color: #0a294a;
    }
  }
  .router-link-active,
  .router-link-exact-active {
    font-weight: 700;
    color: #0a294a;
  }

  .nav-bar {
    border-bottom: 2px solid rgba(220, 220, 220, 10);
    width: 80%;
    @media (max-width: $lg-up) {
      width: 220px;
    }
  }
}
</style>
